import { Typography, type TypographyProps } from '@mui/material'

/**
 * Etiqueta de inteligencia — "REQUIERE ATENCIÓN", "TERRITORIO ACTIVO".
 * REUTILIZA la variante `overline` ya existente (mayúsculas + letter-
 * spacing ya definidos en theme/typography.ts) — no es una tipografía
 * nueva, solo un nombre semántico + color por defecto ajustable.
 */
export function IntelligenceLabel({
  tone = 'default',
  sx,
  ...props
}: TypographyProps & { tone?: 'default' | 'accent' | 'critical' }) {
  const color =
    tone === 'accent' ? 'secondary.main' : tone === 'critical' ? 'error.main' : 'text.secondary'
  return <Typography variant="overline" sx={{ color, fontWeight: 700, ...sx }} {...props} />
}
